import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ordinalNumber',
    standalone: false
})
export class OrdinalNumberPipe implements PipeTransform {

  transform(value: number): unknown {
    return value + this.suffix(value as number);
  }

  private suffix(value: number): string {
    const lastDigit = value % 10;
    const lastTwoDigits = value % 100;
    if (lastDigit == 1 && lastTwoDigits != 11) {
        return 'st';
    } else if (lastDigit == 2 && lastTwoDigits != 12) {
        return 'nd';
    } else if (lastDigit == 3 && lastTwoDigits != 13) {
        return 'rd';
    }
    return 'th';
  }

}
